import { IPropertySuggestion } from './ParagraphSuggestion/ParagraphSuggestion-types';
import {
    IResetSuggestionsAction,
    ISetLoadingSuggestionsAction,
    ISetSuggestionsAction,
    ISetSuggestionsInitialLoadCompletedAction,
    RESET_SUGGESTIONS,
    SET_LOADING_SUGGESTIONS,
    SET_SUGGESTIONS,
    SET_SUGGESTIONS_INITIAL_LOAD_COMPLETED,
} from './ParagraphSuggestions-types';

export function resetSuggestionsAction(): IResetSuggestionsAction {
    return {
        type: RESET_SUGGESTIONS,
    };
}

export function setSuggestionsInitialLoadCompletedAction(
    initialLoadCompleted: boolean
): ISetSuggestionsInitialLoadCompletedAction {
    return {
        type: SET_SUGGESTIONS_INITIAL_LOAD_COMPLETED,
        initialLoadCompleted,
    };
}

export function setSuggestionsLoadingAction(
    loading: boolean
): ISetLoadingSuggestionsAction {
    return {
        type: SET_LOADING_SUGGESTIONS,
        loading,
    };
}

export function setSuggestionsAction(
    suggestions: IPropertySuggestion[],
    nextPageNumber?: number,
    count?: number
): ISetSuggestionsAction {
    return {
        type: SET_SUGGESTIONS,
        suggestions,
        count,
        nextPageNumber,
    };
}
